import React, { useEffect } from "react";
import {
  Anchor,
  Flex,
  Spinner,
} from "discover.medical.react-component-library";
import { fetchMobile } from "../../store/actions/mobile";
import { useDispatch, useStore } from "../../store";
import {
  AppStoreImage,
  Header,
  Description,
  HowToInstallLink,
} from "./_.styled";
import {
  logGoogleLinkClicked,
  logIOSLinkClicked,
  logHowToLinkClicked,
  logMobileViewed,
} from "../../util/analytics";

const Mobile = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    fetchMobile(dispatch);
    logMobileViewed();
  }, [dispatch]);
  const {
    heading,
    description,
    mobileAppLinks,
    howToInstall,
    isFetching,
  } = useStore().mobile;

  const handleLinkClick = (affordance) => {
    affordance === "google"
      ? logGoogleLinkClicked(affordance)
      : logIOSLinkClicked(affordance);
  };

  if (isFetching) {
    return <Spinner />;
  }
  return (
    <>
      <Header
        element="h2"
        fontFamily="secondary"
        color="primary"
        marginBottom="sm"
      >
        {heading}
      </Header>
      <Description element="p" marginBottom="sm">
        {description}
      </Description>
      <Flex container align={{ item: "center" }} wrap marginBottom="sm">
        {mobileAppLinks?.length > 0 &&
          mobileAppLinks.map((link) => (
            <Anchor
              href={link.route}
              key={link.ariaLabel}
              onClick={() => handleLinkClick(link?.telemetryData?.affordance)}
              data-testid={link.ariaLabel}
            >
              <AppStoreImage
                src={link.imageUrl}
                aria-label={link.ariaLabel}
                $appStoreImageWidth={link.imageWidth}
                $appStoreImageHeight={link.imageHeight}
              />
            </Anchor>
          ))}
      </Flex>
      <Description element="p" paddingLeft="xs">
        <HowToInstallLink
          href={howToInstall?.link?.route}
          glyph={howToInstall?.icon?.glyph}
          floatLeft={true}
          onClick={() =>
            logHowToLinkClicked(howToInstall?.telemetryData?.affordance)
          }
          data-testid="howToInstallLink"
        >
          {howToInstall?.link?.label}
        </HowToInstallLink>
        {howToInstall?.text}
      </Description>
    </>
  );
};

Mobile.displayName = "MobilePage";

export default Mobile;
